var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1196,
    height: 1440,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1440h390.6l624.06-212c108.46-36.84 181.34-138.08 181.34-251.9v-.01c0-110.4-68.61-209.35-172.48-248.73L661.98 590.28c-178.57-67.7-296.53-237.82-296.53-427.62V0H0v1440z",
    fill: "#333754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1092 953H582V606h510v347z",
    fill: "#E2812D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1092 953L837 747 582 953h510z",
    fill: "#EC9533"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1092 606L837 796 582 606h510z",
    fill: "#EFA44A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848.6 434h86.8c26.29 0 47.6 21.18 47.6 47.3v61.22c0 20.71-13.42 38.27-32.08 44.67L949.4 620l-42.76-30.18H848.6c-26.29 0-47.6-21.18-47.6-47.3V481.3c0-26.12 21.31-47.3 47.6-47.3z",
    fill: "#B7B7B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M743.77 348h114.46c34.67 0 62.77 27.78 62.77 62.05v80.3c0 34.27-28.1 62.06-62.77 62.06H781.7L725.3 592l-2-43.03c-24.6-8.4-42.3-31.44-42.3-58.62v-80.3c0-34.27 28.1-62.05 62.77-62.05z",
    fill: "#DCDBD6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M795.43 405.74c8.46 0 15.96 1.74 22.5 5.22 6.6 3.42 11.7 8.1 15.3 14.04a36.84 36.84 0 015.49 19.71c0 5.52-.96 10.26-2.88 14.22a20.76 20.76 0 01-7.65 8.91 19.69 19.69 0 01-10.62 2.97c-3.42 0-6.33-.66-8.73-1.98a12.98 12.98 0 01-5.49-5.85c-2.64 5.22-7.2 7.83-13.68 7.83-3.3 0-6.42-.9-9.36-2.7a20.58 20.58 0 01-7.02-7.92 24.94 24.94 0 01-2.7-11.79c0-4.44.87-8.34 2.61-11.7a19.88 19.88 0 017.02-7.83 17.36 17.36 0 019.45-2.79c4.74 0 8.43 1.47 11.07 4.41v-3.6h17.28v25.74c0 3.3 1.17 4.95 3.51 4.95 1.44 0 2.55-.93 3.33-2.79.84-1.86 1.26-5.13 1.26-9.81 0-5.4-1.29-10.2-3.87-14.4a25.6 25.6 0 00-10.8-9.81c-4.62-2.4-9.96-3.6-16.02-3.6-6.06 0-11.43 1.32-16.11 3.96a27.34 27.34 0 00-10.89 10.8 30.52 30.52 0 00-3.87 15.3c0 5.82 1.26 11.04 3.78 15.66a27.66 27.66 0 0010.8 10.71c4.62 2.58 9.93 3.87 15.93 3.87 6.3 0 12.36-1.32 18.18-3.96l3.78 11.07a40.82 40.82 0 01-10.08 3.15 61.34 61.34 0 01-11.88 1.17c-8.82 0-16.62-1.83-23.4-5.49a38.71 38.71 0 01-15.57-14.85 41.99 41.99 0 01-5.49-21.33c0-7.74 1.83-14.76 5.49-21.06a39.81 39.81 0 0115.75-14.94c6.78-3.66 14.64-5.49 23.58-5.49zm-.81 50.94a5.8 5.8 0 004.68-2.16c1.2-1.44 1.8-3.48 1.8-6.12s-.6-4.65-1.8-6.03a5.8 5.8 0 00-4.68-2.16 5.8 5.8 0 00-4.68 2.16c-1.14 1.38-1.71 3.39-1.71 6.03s.57 4.68 1.71 6.12a5.8 5.8 0 004.68 2.16z",
    fill: "#333754"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.13 1111h76.72c21.07 0 38.15-16.97 38.15-37.91V499.91c0-20.94-17.08-37.91-38.15-37.91h-76.72c-41.5 0-75.13 33.43-75.13 74.67v499.66c0 41.24 33.64 74.67 75.13 74.67z",
    fill: "#BD3A4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483 966h-92V608h92v358z",
    fill: "#872B3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.23 658h94.54A38.15 38.15 0 00552 619.92V500.08A38.15 38.15 0 00513.77 462h-94.54A38.15 38.15 0 00381 500.08v119.84A38.15 38.15 0 00419.23 658z",
    fill: "#DD415B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.25 633h60.5A30.24 30.24 0 00527 602.78v-85.56A30.24 30.24 0 00496.75 487h-60.5A30.24 30.24 0 00406 517.22v85.56A30.24 30.24 0 00436.25 633z",
    fill: "#BD3A4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476 512a7 7 0 1014 0 7 7 0 00-14 0zM443 512a7 7 0 1014 0 7 7 0 00-14 0zM493 536a7 7 0 1014 0 7 7 0 00-14 0zM460 536a7 7 0 1014 0 7 7 0 00-14 0zM427 536a7 7 0 1014 0 7 7 0 00-14 0zM509 560a7 7 0 1014 0 7 7 0 00-14 0zM476 560a7 7 0 1014 0 7 7 0 00-14 0zM443 560a7 7 0 1014 0 7 7 0 00-14 0zM411 560a7 7 0 1014 0 7 7 0 00-14 0zM493 584a7 7 0 1014 0 7 7 0 00-14 0zM460 584a7 7 0 1014 0 7 7 0 00-14 0zM427 584a7 7 0 1014 0 7 7 0 00-14 0zM476 607a7 7 0 1014 0 7 7 0 00-14 0zM443 607a7 7 0 1014 0 7 7 0 00-14 0z",
    fill: "#441A21"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.23 1111h94.54a38.15 38.15 0 0038.23-38.08V953.08A38.15 38.15 0 00513.77 915h-94.54A38.15 38.15 0 00381 953.08v119.84a38.15 38.15 0 0038.23 38.08z",
    fill: "#DD415B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.25 1086h60.5a30.23 30.23 0 0030.25-30.22v-85.56A30.24 30.24 0 00496.75 940h-60.5A30.24 30.24 0 00406 970.22v85.56a30.24 30.24 0 0030.25 30.22z",
    fill: "#BD3A4D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476 966a7 7 0 1014 0 7 7 0 00-14 0zM443 966a7 7 0 1014 0 7 7 0 00-14 0zM493 990a7 7 0 1014 0 7 7 0 00-14 0zM460 990a7 7 0 1014 0 7 7 0 00-14 0zM427 990a7 7 0 1014 0 7 7 0 00-14 0zM509 1014a7 7 0 1014 0 7 7 0 00-14 0zM476 1014a7 7 0 1014 0 7 7 0 00-14 0zM443 1014a7 7 0 1014 0 7 7 0 00-14 0zM411 1014a7 7 0 1014 0 7 7 0 00-14 0zM493 1038a7 7 0 1014 0 7 7 0 00-14 0zM460 1038a7 7 0 1014 0 7 7 0 00-14 0zM427 1038a7 7 0 1014 0 7 7 0 00-14 0zM476 1062a7 7 0 1014 0 7 7 0 00-14 0zM443 1062a7 7 0 1014 0 7 7 0 00-14 0z",
    fill: "#441A21"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M841.25 952v45.54c0 9.76 3.97 18.57 10.41 24.97a35.55 35.55 0 0025.16 10.35h81.07a29 29 0 0129.11 28.91 29.02 29.02 0 01-29.1 28.91H740.17a20.12 20.12 0 00-14.23 5.85 19.84 19.84 0 00-5.9 14.14c0 5.53 2.25 10.5 5.9 14.13a20.13 20.13 0 0014.23 5.86h137c26.5 0 48 21.34 48 47.67 0 26.33-21.5 47.67-48 47.67H446.36c-26.72 0-48.37-21.5-48.37-48.03v-66.79h8.7v66.79a39.1 39.1 0 0011.62 27.85 39.66 39.66 0 0028.05 11.53h430.8a39.27 39.27 0 0027.79-11.43 38.73 38.73 0 0011.5-27.59c0-10.79-4.38-20.52-11.5-27.6a39.32 39.32 0 00-27.79-11.43H740.18a28.74 28.74 0 01-28.83-28.63 28.74 28.74 0 0128.83-28.64H957.9a20.4 20.4 0 0014.43-5.93 20.12 20.12 0 005.97-14.33 20.1 20.1 0 00-5.97-14.33 20.4 20.4 0 00-14.43-5.93h-81.07c-24.46-.01-44.28-19.69-44.28-43.97V952h8.7z",
    fill: "#FFFFFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.43 1089a111.77 111.77 0 0031.57-77.63c0-21.22-6.15-41.9-17.36-59.6h-17.1V936L562 951.98a82.29 82.29 0 0125.55 59.39c0 22.37-9.31 43.92-25.55 59.4l23.43 18.23z",
    fill: "#9397A5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582 952l11-8.82c-2.51-3.2-5.2-6.26-8.08-9.18l-2.92 2.25V952z",
    fill: "#F2C17D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582 952h17c-1.91-3.1-3.98-6.1-6.18-9L582 952z",
    fill: "#F8CB8D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.48 1130A176.95 176.95 0 00682 1011.89 175.5 175.5 0 00671.43 952h-31.97a146.47 146.47 0 0112.87 59.89c0 37-14.21 72.78-39.33 99.9l23.48 18.21z",
    fill: "#9397A5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.6 922l23.4-18.67c-2.3-2.84-4.67-5.62-7.15-8.33L613 913.24c2.66 2.83 5.2 5.75 7.6 8.76z",
    fill: "#F2C17D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 953h32a178.03 178.03 0 00-27.95-50L621 921.66c7.63 9.66 14 20.2 19 31.34z",
    fill: "#F8CB8D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.32 1280l195.38-.02c10.66 0 19.3-8.6 19.3-19.21v-60.8c0-10.6-8.65-19.19-19.32-19.19V1143l-36.04 37.78-159.33.02c-10.67 0-19.31 8.6-19.31 19.2v60.8c0 10.61 8.65 19.2 19.32 19.2z",
    fill: "#3B518A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327 1227.56a15.5 15.5 0 11-31.01-.13 15.5 15.5 0 0131.01.13zM397 1227.56a15.5 15.5 0 11-31.01-.13 15.5 15.5 0 0131.01.13zM467 1228.56a15.5 15.5 0 11-31-.13 15.5 15.5 0 0131 .13z",
    fill: "#222B47"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurved);
export default __webpack_public_path__ + "static/media/curved.e252d8bf14208f07c4e69e9570c5d4dd.svg";
export { ForwardRef as ReactComponent };